
import Right from './index.vue'

Right.install = function (Vue) {
  Vue.component(Right.name, Right)
}

export default Right